import React from 'react';
import { useTranslation } from 'react-i18next';

import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';

import { SUPPORT } from 'business/constants';
import { MODULES_TRANSLATION_PATH } from '../helpers/constants';

const StyListItemText = styled(ListItemText)({
    margin: 0,
    '.MuiListItemText-primary': {
        fontSize: '0.75rem',
        lineHeight: 'inherit',
    },
});

const SupportTooltip = (): JSX.Element => {
    const { t } = useTranslation();

    return (
        <>
            {t(`${MODULES_TRANSLATION_PATH}.descriptions.${SUPPORT}.context`)}
            <List>
                {Array.from({ length: 5 }, (_, i) => i.toString()).map(
                    (idx) => (
                        <StyListItemText key={idx}>
                            -{' '}
                            {t(
                                `${MODULES_TRANSLATION_PATH}.descriptions.${SUPPORT}.rightsAccess.${idx}`,
                            )}
                        </StyListItemText>
                    ),
                )}
            </List>
        </>
    );
};

export default SupportTooltip;
